import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Gift, Sparkle } from "@phosphor-icons/react";

export function ComplimentaryInsightDialog({ open, onOpenChange, comp, onChoose }) {
  const claimed = comp?.claimed;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="complimentary-insight-dialog" className="border-[#4A4540]/15 bg-[#FDFBF7] sm:max-w-md">
        <DialogTitle className="sr-only">Your complimentary Memory Insight</DialogTitle>
        <DialogDescription className="sr-only">One free Memory Insight after five Childhood memories</DialogDescription>
        <div className="flex items-center gap-2 text-[#A84A32]">
          <Gift size={22} weight="duotone" />
          <span className="text-sm font-medium uppercase tracking-wide">A little gift for you</span>
        </div>
        <h2 className="mt-1 font-serif text-3xl leading-tight text-[#2C2A28]">
          {claimed ? "Your complimentary Memory Insight" : "Your first Memory Insight is on us"}
        </h2>
        <p className="mt-2 text-[#4A4540]">
          {claimed
            ? "It's saved with the memory you chose. Open it anytime to reread or download it."
            : "You've written five Childhood memories. Open any one of them and choose Memory Insight — we'll write a short, kind insight about that moment, free."}
        </p>
        <Button data-testid="complimentary-choose-btn" onClick={onChoose}
          className="mt-5 w-full rounded-full bg-[#A84A32] py-6 text-base text-white hover:bg-[#8f3e29]">
          <Sparkle size={18} weight="duotone" className="mr-2" />
          {claimed ? "Open my Memory Insight" : "Choose a Childhood memory"}
        </Button>
      </DialogContent>
    </Dialog>
  );
}
